const TEXTURE =
  "https://static.prod-images.emergentagent.com/jobs/b0925e6a-374a-4fa0-bd07-856a7fe9fb4a/images/ef9a8a67f1464558858e517ae0e05d8a90544099143c5dd6aeda55df311f131a.png";

const features = [
  {
    title: "Professional Cleaning Products & Surface Care",
    body: "We use professional cleaning chemicals and equipment selected for different surfaces and working environments. Every product is supported by Safety Data Sheets (SDS), and our staff are trained in safe chemical handling.",
  },
  {
    title: "Advanced Material Protection",
    body: "Our expert analyzes your specific flooring, stones, metals, and fabrics to apply the exact chemical formula required — completely preventing any surface damage.",
  },
  {
    title: "COSHH Compliance",
    body: "Every exclusive chemical product used by AGS is fully logged with corresponding Safety Data Sheets (SDS), ensuring absolute safety for your staff and premises.",
  },
];

export default function InHouseExpertise() {
  return (
    <section
      id="expertise"
      data-testid="expertise-section"
      className="relative bg-[#0E2A57] text-white py-28 md:py-40 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-25 mix-blend-screen"
        style={{
          backgroundImage: `url(${TEXTURE})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 bg-gradient-to-b from-[#0E2A57]/40 via-[#0E2A57]/70 to-[#081A37]"
      />

      <div className="relative container-ags">
        <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#BEE7F5] font-medium">
          09 — In-House Industrial & Hospital Product Expertise
        </span>
        <h2 className="mt-6 font-heading font-extrabold text-4xl md:text-6xl lg:text-[4.5rem] leading-[1.0] tracking-[-0.04em] max-w-4xl">
          We don't believe in
          <span className="italic-display font-normal text-[#BEE7F5]"> ordinary </span>
          solutions.
        </h2>
        <p className="mt-6 text-white/75 text-lg md:text-2xl leading-[1.55] max-w-2xl">
          We use professional cleaning chemicals and equipment selected for
          different surfaces and working environments. Every product is
          supported by Safety Data Sheets (SDS), and our staff are trained in
          safe chemical handling.
        </p>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/15 border border-white/20">
          {features.map((f, i) => (
            <div
              key={f.title}
              data-testid={`expertise-feature-${i}`}
              className="bg-[#050B14] p-8 md:p-10 hover:bg-[#0E2A57] transition-colors duration-500 min-h-[300px] flex flex-col"
            >
              <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#2BB6E5] font-medium">
                {String(i + 1).padStart(2, "0")} / 03
              </div>
              <h3 className="mt-6 font-heading font-bold text-2xl tracking-[-0.025em] text-white">
                {f.title}
              </h3>
              <p className="mt-4 text-white/75 text-base leading-[1.6]">
                {f.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
